<template>
  <div>音乐</div>
</template>

<script>
export default {

}
</script>

<style>

</style>